<template>
  <!--footer-->
  <div class="footer">
    <div class="main footer-center">
      <div class="bottom clearfix">
        <!--底部导航开始-->
        <div class="bNav fl">
          <dl class="item">
            <dt><router-link to="/home">网站导航</router-link></dt>
            <dd><router-link to="/home" >网站首页</router-link></dd>
            <dd><router-link to="/about" >公司简介</router-link></dd>
            <dd><router-link to="/news" >新闻中心</router-link></dd>
            <dd><router-link to="/product" >产品中心</router-link></dd>
            <dd><router-link to="/contractUs" >联系我们</router-link></dd>
          </dl>

        </div>
        <!--底部导航结束-->

        <!--联系方式开始-->
<!--        <div class="contact_info fl">
          <p class="p1">24小时咨询服务电话</p>
          <p class="dh">18916006004</p>
          <p class="tel1">联系人：母元崧</p>
          <p class="tel1">QQ：2335150059</p>
          <p class="tel1">手机：18916006004（微信同号）</p>
          <p class="tel1">询价邮箱：2335150059@qq.com</p>
          <p class="tel1">地址：上海市青浦区外青松公路7888号15幢三层A区1314室</p>
          <p class="tel1">  </p>
        </div>-->
        <!--联系方式结束-->

        <!--二维码开始-->
        <div class="ewm fl">
          <dl>
            <dt><img src="@/images/qcord.png?=111"></dt>
            <dd>微信扫码 联系我们</dd>
          </dl>
        </div>
        <!--二维码结束-->
      </div>

      <div class="links">
        <div style="width:100%;margin:0 auto;">
          <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33028202000892" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
            <img src="@/assets/benantuicon.png" style="float:left;"/>
            <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">沪ICP备2024078723号</p>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.links {
  margin-bottom: 8px;
}
</style>
